module.exports = __webpack_public_path__ + "9a6cf43247bf4c3024eabccb5c3e6e30.svg";